module.exports = __webpack_public_path__ + "img/cliffs.cd09643b.png";